export type Serialized<T> = T extends string ? T : string & T;

export function serialize<T>(json: T): Serialized<T> {
  return JSON.stringify(json) as Serialized<T>;
}

export function deserialize<T>(serialized: Serialized<T>): T {
  return JSON.parse(serialized as string);
}
